import React from "react";
import { MultiStepEditSection } from "components/MainSectionTemplate/MultiStepEditSectionTemplate";
import { ExternalCalendarFormState, NewExternalCalendarStep } from "./model";
import { ICalendarUrlInput } from "components/ValidatedFields/ICalendarUrlInput";

export const externalCalendarConnectSection = (
  externalCalendarFormState: ExternalCalendarFormState,
  setExternalCalendarFormState: (state: ExternalCalendarFormState) => void,
  peekICalendarUrl: string,
): MultiStepEditSection<NewExternalCalendarStep> => ({
  getNextSection: () => "externalCalendarConfigure",
  getPrevSection: () => "chooseCalendarType",
  isLastStep: () => false,
  sectionSteps: [{
    title: RESX.ConnectedAccount.Connect,
    isActive: true,
  }, {
    title: RESX.GeneralLabels.Configure,
    isActive: false,
  }],
  section: {
    type: "regular",
    key: "externalCalendarConnect",
    title: RESX.ExternalCalendar.NewExternalCalendar,
    fields: [{
      key: "type",
      label: RESX.GeneralLabels.Type,
      renderEditNew: () => <div className="main-section-template-fields-padding">
        External iCalendar
      </div>,
    }, {
      key: "iCalendarUrl",
      label: RESX.ExternalCalendar.iCalendarUrl,
      renderEditNew: () => <ICalendarUrlInput
        validatorKey="iCalendarUrl"
        peekICalendarUrl={peekICalendarUrl}
        value={externalCalendarFormState.iCalendarUrl}
        onChange={v => setExternalCalendarFormState({ ...externalCalendarFormState, iCalendarUrl: v })}
        onOutcomeChange={outcome => setExternalCalendarFormState({
          ...externalCalendarFormState,
          name: outcome.data.calendarName,
          eventCount: outcome.data.eventCount,
        })}
      />
    }]
  }
});